import { Controller } from "stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = ["goldTypeCalculation", "cashGoldTypeCalculation", "modal"]

  connect() {
  }

  updateGoldPrice(event) {
    event.preventDefault(event);
    this.updateCalculation();
  }

  updateCashGoldPrice(event) {
    event.preventDefault(event);
    this.updateCashCalculation();
  }

  numberWithDelimiter(x) {
    if (x === 0) {
      return "0,00 g";
    } else {
      return (x / 100).toString().replace(".", ",") + " g";
    }
  }

  async updateCalculation() {
    let csrfToken = document.head.querySelector("meta[name=\"csrf-token\"]") ? document.head.querySelector("meta[name=\"csrf-token\"]").content : "";
    const target = this.goldTypeCalculationTarget;
    let response = 0;
    if (target.value === "delivery_fee_partial_payers") {
      document.getElementById("setup_delivery_fee_partial_payers").classList.remove("d-none");
    } else {
      document.getElementById("setup_delivery_fee_partial_payers").classList.add("d-none");
      response = await fetch(`${window.location.origin}/admin/payment_transactions/${target.id}/calculate_price?type=${target.value}`, {
        method: "GET",
        headers: {
          "X-CSRF-TOKEN": csrfToken,
          "Content-Type": "application/json"
        },
      }).then(response => response.json());

      if (response.valid) {
        const transaction = response.transaction;
        document.getElementsByClassName("gold_weight")[0].textContent = this.numberWithDelimiter(transaction.gold_weight);
        document.getElementsByClassName("total_gold_weight")[0].textContent = this.numberWithDelimiter(transaction.total_gold_weight);
        document.getElementsByClassName("bonus_gold_weight")[0].textContent = this.numberWithDelimiter(transaction.bonus_gold_weight);
      }
      location.reload();
    }
  }

  async submitSetupDeliveryPayers(event) {
    event.preventDefault(event);
    let csrfToken = document.head.querySelector("meta[name=\"csrf-token\"]") ? document.head.querySelector("meta[name=\"csrf-token\"]").content : "";
    let paidAmount = document.getElementById("payment_transaction_delivery_fee_partial_payers");
    if (paidAmount === null) {
      paidAmount = document.getElementById("cash_payment_delivery_fee_partial_payers");
    }
    let button = document.getElementById("pt_delivery_fee_partial_payers");
    let paymentTransactionId = [button.getAttribute("data-payment-transaction-id"), "paymentTransaction"];
    if (paymentTransactionId[0] === null) {
      paymentTransactionId = [button.getAttribute("data-cash-payment"), "cashPayment"];
    }
    let response = 0;
    if (this.invalidInputs() === 0) {
      response = await fetch(`${window.location.origin}/admin/payment_transactions/setup_delivery_fee_partial_payers?payment_type=delivery_fee_partial_payers&delivery_fee_partial_payers=${paidAmount.value}&transaction_id=${paymentTransactionId}`, {
        method: "GET",
        headers: {
          "X-CSRF-TOKEN": csrfToken,
          "Content-Type": "application/json"
        },
      }).then(response => response.json());

      if (response.valid) {
        const transaction = response.transaction;
        if (document.getElementsByClassName("gold_weight").length === 0) {
          document.getElementsByClassName("weight")[0].textContent = this.numberWithDelimiter(transaction.weight);
          document.getElementsByClassName("total_weight")[0].textContent = this.numberWithDelimiter(transaction.total_weight);
          document.getElementsByClassName("bonus_weight")[0].textContent = this.numberWithDelimiter(transaction.bonus_weight);
        } else {
          document.getElementsByClassName("gold_weight")[0].textContent = this.numberWithDelimiter(transaction.gold_weight);
          document.getElementsByClassName("total_gold_weight")[0].textContent = this.numberWithDelimiter(transaction.total_gold_weight);
          document.getElementsByClassName("bonus_gold_weight")[0].textContent = this.numberWithDelimiter(transaction.bonus_gold_weight);
        }
      }
      location.reload();
    } else {
      this.scrollToInvalids();
    }
  }

  invalidInputs() {
    let invalidInputs = [];
    document.querySelectorAll("input.required").forEach(function (input) {
      if (input.value === "" || input.value === "0" || input.value === "0.0" || parseFloat(input.value) < 0) {
        input.classList.add("is-invalid");
        invalidInputs.push(input);
      } else {
        input.classList.remove("is-invalid");
      }
    });

    return invalidInputs.length;
  }

  scrollToInvalids() {
    let container = $(".wrapper.full").length ? $(".wrapper.full") : $([document.documentElement, document.body]);
    container.scrollTop(0);
  }

  async updateCashCalculation() {
    let csrfCashToken = document.head.querySelector("meta[name=\"csrf-token\"]") ? document.head.querySelector("meta[name=\"csrf-token\"]").content : "";
    const cashTarget = this.cashGoldTypeCalculationTarget;
    if (cashTarget.value === "delivery_fee_partial_payers") {
      document.getElementById("setup_delivery_fee_partial_payers").classList.remove("d-none");
    } else {
      document.getElementById("setup_delivery_fee_partial_payers").classList.add("d-none");
      const cashResponse = await fetch(`${window.location.origin}/admin/payment_transactions/calculate_cash_price?cash_type=${cashTarget.value}&cash_payment_id=${cashTarget.id}`, {
        method: "GET",
        headers: {
          "X-CSRF-TOKEN": csrfCashToken,
          "Content-Type": "application/json"
        },
      }).then(cashResponse => cashResponse.json());
      if (cashResponse.valid) {
        const cashPayment = cashResponse.transaction;
        document.getElementsByClassName("weight")[0].textContent = this.numberWithDelimiter(cashPayment.weight);
        document.getElementsByClassName("total_weight")[0].textContent = this.numberWithDelimiter(cashPayment.total_weight);
        document.getElementsByClassName("bonus_weight")[0].textContent = this.numberWithDelimiter(cashPayment.bonus_weight);
      }
      location.reload();
    }
  }
  
  async updatePdfTransaction(e) {
    e.preventDefault();
    
    const spinner = document.getElementById("checkbox-loader");
    spinner.classList.remove("d-none");
    
    const checkbox = e.target;
    const transactionId = checkbox.getAttribute("data-id");
    const fieldName = checkbox.getAttribute("data-field");
    const link = `${transactionId}/update_${fieldName}`;
    
    const data = new FormData();
    data.append(`payment_transaction[${fieldName}]`, checkbox.checked);
    
    Rails.ajax({
      type: "post",
      url: link,
      data
    });
  }
}
